import './autoHideScrollbar.css'

export const ROOT_SCROLLBAR_IDLE_MS = 800
export const ROOT_SCROLLBAR_EDGE_PX = 20

function canUseDOM() {
  return typeof window !== 'undefined' && typeof document !== 'undefined'
}

export function isNearRootScrollbar(clientX: number, viewportWidth: number, edge = ROOT_SCROLLBAR_EDGE_PX) {
  return clientX >= 0 && viewportWidth > 0 && viewportWidth - clientX <= edge
}

export function initAutoHideRootScrollbar() {
  if (!canUseDOM()) return () => undefined
  const root = document.documentElement
  let hideTimer = 0

  const hide = () => {
    window.clearTimeout(hideTimer)
    root.removeAttribute('data-scrollbar-active')
  }
  const reveal = () => {
    root.setAttribute('data-scrollbar-active', 'true')
    window.clearTimeout(hideTimer)
    hideTimer = window.setTimeout(hide, ROOT_SCROLLBAR_IDLE_MS)
  }
  const onPointerMove = (event: PointerEvent) => {
    if (isNearRootScrollbar(event.clientX, window.innerWidth)) reveal()
  }
  const onVisibilityChange = () => {
    if (document.visibilityState !== 'visible') hide()
  }

  root.setAttribute('data-auto-hide-scrollbar', 'true')
  window.addEventListener('scroll', reveal, { passive: true })
  window.addEventListener('wheel', reveal, { passive: true })
  window.addEventListener('pointermove', onPointerMove, { passive: true })
  document.addEventListener('visibilitychange', onVisibilityChange)

  return () => {
    hide()
    root.removeAttribute('data-auto-hide-scrollbar')
    window.removeEventListener('scroll', reveal)
    window.removeEventListener('wheel', reveal)
    window.removeEventListener('pointermove', onPointerMove)
    document.removeEventListener('visibilitychange', onVisibilityChange)
  }
}

const disposeAutoHideScrollbar = canUseDOM() ? initAutoHideRootScrollbar() : undefined
if (import.meta.hot && disposeAutoHideScrollbar) import.meta.hot.dispose(disposeAutoHideScrollbar)
